import { QRCode } from "react-qrcode-logo";
import React, { useState } from "react";
import logo from "../Mofa/mofa.svg";

import "./multiple.css";

export default function MultipleQR({ setChooseBox }) {
  const [qrList, setQrList] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const [inp, count] = e.target;
    const fileName = inp.value;
    const number = Number(fileName.match(/\d+/)[0]) || 0;
    const countValue = Number(count.value || 0);
    setQrList([...Array(countValue)].map((_, i) => fileName.replace(/\d+/, number + i)));
  };

  return (
    <div className="multiple-qr-container">
      <h1>Welcome To Multiple QR Generator Page</h1>
      <p>Please Enter the first fileName</p>
      <form onSubmit={handleSubmit}>
        <input type="text" name="file" required placeholder="Please Enter Filename" pattern="(?=.*\d)[A-Za-z0-9]+" title="Please Enter name must contain a number" />
        <input type="number" required placeholder="Number of QR Codes" min={1} title="Please enter the number of QR codes to generate" />
        <button type="submit">Generate QR</button>
      </form>
      <div className="qr-list-main">
        {qrList.map((item) => (
          <div className="qr-generate-box" key={item}>
            <div className="mofa-qr">
              <QRCode
                size={170}
                value={process.env.REACT_APP_MOFA_PREFIX + item + ".pdf"}
                logoImage={logo}
                logoHeight={40}
                logoWidth={35}
                removeQrCodeBehindLogo={true}
                qrStyle="dots"
                eyeRadius={[
                  [0, 7, 0, 7],
                  [0, 7, 0, 7],
                  [0, 7, 0, 7],
                ]}
              />
            </div>
            <p>Ministry of Foreign Affairs, Pakistan</p>
            <b>{item}</b>
          </div>
        ))}
      </div>
      {!!qrList.length && (
        <button className="print-btn" onClick={() => window.print()}>
          Print
        </button>
      )}
      <button className="done-button" onClick={() => setChooseBox("")}>
        Done
      </button>
    </div>
  );
}
